export const environment = {
  production: false,
  apiUrl: 'https://dev-api.knostos.com/mobile-gateway/api/v1',
  tutorialsURL: 'https://www.medpluspr.com/medlinkappen',
  surveyUrl: 'https://www.medpluspr.com/customersurvey',
  tosUrl: 'https://www.medpluspr.com/medlinkterms',
  privacyUrl: 'https://www.medpluspr.com/medlinkprivacy',
  contactUsUrl: 'https://www.medpluspr.com/contactus',
  // LUNCHDARKLY_SDK_KEY: '66efe25c4eb8ad104ec76310',
  chatDepartmentId: '5e609d4545b3877381866837',
  chatUrl: 'https://engagedev.knostos.com/',
  appVersion: '3.0.10',
  buildNumber: '57',
};
